import { Category } from '../services/network'
import dayjs from 'dayjs'
import { log } from './logger'
function isCardExpired(expirationDate: string): boolean {
  // Split the expiration date into month and year
  if (expirationDate === 'string') {
    return false
  }
  const [expMonth, expYear] = expirationDate.split('/').map(Number)

  // Get the current month and year
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth() + 1 // JavaScript months are 0-11
  const currentYear = currentDate.getFullYear() % 100 // Get last two digits of the year

  // Compare expiration year and month with current year and month
  if (expYear < currentYear) {
    return true
  } else if (expYear === currentYear && expMonth < currentMonth) {
    return true
  }

  return false
}

function formatDateToString(date: Date): string {
  if (!dayjs(date).isValid()) {
    throw new Error('Invalid Date object')
  }

  return dayjs(date).format('DD-MM-YYYY')
}

function formatDate(dateString: string): string {
  return dayjs(dateString).format('DD-MM-YYYY')
}

const formatISODate = (isoDateString: string): string => {
  const date = dayjs(isoDateString)

  if (!date.isValid()) {
    throw new Error('Invalid ISO date string')
  }

  return date.format('DD/MM/YYYY HH:mm')
}

function findCategoryByActivityId(categories: Category[], activityId: string): string | null {
  const category = categories.find((category) => category.activities?.some((activity) => activity.id === activityId))

  return category ? category.id : null // Return the category ID where the activity is found
}

const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

const convertDateToItalian = (dateString: string): string => {
  return `${dayjs(dateString).locale('it').format(`DD/MM/YYYY`)}`
}

export const getErrorMessage = (error: any): string => {
  if (error.stripeErrorCode) {
    log.warn(`[Stripe error] ${JSON.stringify(error)}`)
    log.warn(`returning`, `stripe_error.${error.declineCode ?? error.stripeErrorCode}`)
    return `stripe_error.${error.declineCode ?? error.stripeErrorCode}`
  }
  if (error.status) {
    if (error.status >= 500) {
      log.debug(`[error.status >= 500] ${error.statusText} (${error.status}): ${error.response.data.message}`)
      switch (error.status) {
        case 500:
          if (error.response.data.message) {
            return JSON.parse(error.response.data.message).message
          }
          return `Internal Server Error. Please retry!`
        case 503:
          return `Temporary unavailable. Please retry!`
        default:
          return `Server error ${error.status}. Please retry!`
      }
    }
  }
  if (error.response?.data) {
    if (error.response?.data.message) {
      try {
        const data = JSON.parse(error.response?.data.message)
        if (data.message) {
          log.debug(`[getErrorMessage] Error on path ${JSON.stringify(data)}`)
          return data.message
        }
      } catch (e) {
        log.error(`[getErrorMessage] error while parsing`, e)
      }

      return error.response.data.message
    }
  }
  if (error.message) {
    log.debug(`[error.message] ${error.message}`)
    if (error.message === 'Network Error') {
      return `offline`
    }
    return error.message
  }
  return 'api_error_message'
}

export { isCardExpired, formatDateToString, findCategoryByActivityId, formatDate, formatISODate, isValidEmail, convertDateToItalian }
